// removed by extract-text-webpack-plugin
module.exports = {"avatarList":"antd-pro_-_-scaffold-src-components-AvatarList-avatarList","avatarItem":"antd-pro_-_-scaffold-src-components-AvatarList-avatarItem","avatarItemLarge":"antd-pro_-_-scaffold-src-components-AvatarList-avatarItemLarge","avatarItemSmall":"antd-pro_-_-scaffold-src-components-AvatarList-avatarItemSmall","avatarItemMini":"antd-pro_-_-scaffold-src-components-AvatarList-avatarItemMini"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/AvatarList/index.less
// module id = 421
// module chunks = 0 1